'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEmptyString = isEmptyString;
exports.convertPlural2Singular = convertPlural2Singular;
exports.checkStringInclusion = checkStringInclusion;
exports.convertToBoolean = convertToBoolean;
function isEmptyString(str) {
  return !str || str === '';
}

function convertPlural2Singular(str) {
  // if the word ends with 's' and does not end with 'ss', chop the s off and return the result
  // else just return the word
  if (str.endsWith('s') && !str.endsWith('s', str.length - 1)) {
    return str.substring(0, str.length - 1);
  } else {
    return str;
  }
}

function checkStringInclusion(str1, str2) {
  // returns true if either string is contained in the other.
  str1 = str1.toLowerCase();
  str2 = str2.toLowerCase();
  return str1.includes(str2) || str2.includes(str1);
}

function convertToBoolean(input) {
  var returnValue = false;
  input = typeof input === 'string' ? input.toLowerCase() : input;

  switch (input) {
    case true:
    case 1:
    case 'true':
      returnValue = true;
      break;
    case false:
    case 0:
    case 'false':
      returnValue = false;
      break;
  }

  return returnValue;
}
//# sourceMappingURL=stringUtils.js.map